import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FilterInput } from '@it2go/data-grid';
import { Operator } from '../../../../../../../../../data-grid/src/grid/grid-request.dto';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { clientChipField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import { TableColumn, TableColumnAlignment } from '../../../../../shared/components/kit/table/table.types';
import { DebtorsWidgetStore } from './debtors-widget.store';
import { debtorsFrag } from './debtors-widget.query';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { FormatNumberPipe } from '../../../../../shared/pipes/format-number.pipe';
import { LocalDatePipe } from '../../../../../shared/pipes/local-date.pipe';
import { UserChipComponent } from '../../../../../../components/kit/user-chip/user-chip.component';
import { UserChipRenderTypeEnum } from '../../../../../../components/kit/user-chip/user-chip.component.types';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-debtors-widget',
    templateUrl: './debtors-widget.component.html',
    styleUrl: './debtors-widget.component.scss',
    providers: [DebtorsWidgetStore],
    imports: [
        TableComponent,
        PrimeTemplate,
        TranslatePipe,
        FormatNumberPipe,
        LocalDatePipe,
        UserChipComponent,
        ButtonComponent,
    ],
})
export class DebtorsWidgetComponent {
    protected readonly store = inject(DebtorsWidgetStore);
    protected readonly router = inject(Router);

    protected readonly prefix = 'dashboard.debtors.';
    protected readonly UserChipRenderTypeEnum = UserChipRenderTypeEnum;

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected readonly additionalFilter = computed<FilterInput[][]>(() => [[{
        column: 'serviceId',
        operator: Operator.IN,
        value: this.items().map(item => item.serviceId),
    }]]);

    protected readonly columns = computed<TableColumn[]>(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            clientChipField('client', 'person', false),
            {
                name: 'debt',
                sortable: false,
                filterable: false,
                alignment: TableColumnAlignment.Right,
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected openBilling(folderId: number, documentId: number) {
        this.router.navigate(['/content/social/folders', folderId, 'social-folder-billing', documentId]).then();
    }

    protected readonly fragment = debtorsFrag;
}
